import { Txt } from 'components/Txt';
import { theme } from 'lib/theme';
import React from 'react';
import { StyleSheet, View } from 'react-native';

interface Props {
  item: {
    by: string;
    date: string | null;
    comment: string | null;
    status: string | null;
    statusType: string | null;
  };
}

export const ListItem: React.FC<Props> = ({ item }) => {
  return (
    <View style={styles.viewStyle}>
      <View style={styles.main}>
        <Txt>
          {item.by}
          {item.date ? ` — ${item.date}` : ''}
        </Txt>
        {!!item.comment && <Txt style={styles.comment}>{item.comment}</Txt>}
      </View>
      <View style={styles.status}>
        {!!item.status && (
          <View style={styles.chip}>
            <Txt size="small">{item.status}</Txt>
          </View>
        )}
        {!!item.statusType && <Txt size="xsmall">{item.statusType}</Txt>}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  chip: {
    alignItems: 'center',
    borderColor: '#DDDDDD',
    borderRadius: 11,
    borderWidth: 1,
    height: 21,
    justifyContent: 'center',
    marginLeft: -theme.grid / 2,
    marginRight: theme.grid / 2,
    paddingHorizontal: theme.grid / 2,
  },
  comment: {
    color: 'rgba(0,0,0,0.54)',
    lineHeight: 21,
  },
  main: {
    marginBottom: 2,
  },
  status: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  viewStyle: {
    marginVertical: 12,
    paddingHorizontal: theme.padding,
  },
});
